import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { ToastIcon, ToastState } from '@app/shared/services/models/toast.models';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastService } from '@app/shared/services/toast.service';
import { UpperCasePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'ic-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [UpperCasePipe, TranslatePipe]
})
export class ToastComponent implements OnInit {
    private readonly destroyRef = inject(DestroyRef);

    // public: bound from toast.component.html
    public toastService = inject(ToastService);

    protected readonly ToastIcon = ToastIcon;

    // Signals: the toast is shown from service calls anywhere in the app (ADR 0008, AB#23266).
    protected readonly state = signal<ToastState>({ visible: false });
    protected readonly iconPath = signal('');

    ngOnInit() {
        this.toastService.state$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(s => {
                this.state.set(s);
                this.iconPath.set(this.getIconPath());
            });

    }

    getIconPath(): string {
        switch (this.state().icon) {
            case ToastIcon.Success:
                return "/assets/svg/toast-success.svg";

            case ToastIcon.Error:
                return "/assets/svg/toast-error.svg";

            case ToastIcon.Warning:
                return "/assets/svg/toast-warning.svg";

            case ToastIcon.Information:
                return "/assets/svg/toast-info.svg";

            default:
                return "";
        }
    }

}
